import type * as FormData from 'form-data';
export const X_TC_USERID = Symbol.for('x-tc-userid');
export const AXIOS_CONFIGURATION = Symbol.for('axios-configuration');
export * from './ObjectSerializer.js';

export interface RequestDetailedFile {
    value: Buffer | NodeJS.ReadableStream | string;
    options?: Pick<FormData.AppendOptions, 'filename' | 'contentType' | 'knownLength' | 'header'>;
}

export type RequestFile = RequestDetailedFile['value'] | RequestDetailedFile;

export * from './serviceClient.js';
export * from './axiosHelpers.js';
